
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9RwzH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6308a072be72cc5a$export$2e2bcd8739ae039);

var $9DB7T = parcelRequire("9DB7T");


var $44C5Y = parcelRequire("44C5Y");
const $6308a072be72cc5a$var$getData = async ()=>{
    const [view, isDiscoPushComplete] = await Promise.all([
        (0, $44C5Y.resolved)(()=>(0, $9DB7T.userPreferenceAPI).get((0, $0f8f8ea7f8143316$export$15187a597cef02df)), 'modal'),
        (0, $44C5Y.resolved)(()=>(0, $9DB7T.userPreferenceAPI).get((0, $0f8f8ea7f8143316$export$8977f91a75d8d265)), false)
    ]);
    return {
        view: view,
        isDiscoPushComplete: isDiscoPushComplete
    };
};
var $6308a072be72cc5a$export$2e2bcd8739ae039 = $6308a072be72cc5a$var$getData;

});
const $0f8f8ea7f8143316$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $0f8f8ea7f8143316$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $0f8f8ea7f8143316$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("44C5Y", function(module, exports) {
$parcel$export(module.exports, "resolved", () => $fbb0134f48a539fc$export$d06d16b20ced9190);

var $gYnSx = parcelRequire("gYnSx");
const $fbb0134f48a539fc$export$d06d16b20ced9190 = async (promise, fallback)=>{
    try {
        const result = await promise();
        return result ?? fallback;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode !== 404) (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'persistentIssueCreateModalViewResource',
                packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                teamName: 'gryffindor'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return fallback;
    }
};

});



//# sourceMappingURL=async-router-resources-persistent-issue-create-modal-view.0cdc9015.js.map
